import React from 'react';
import { withTranslation } from 'react-i18next';

import { trackEvent } from 'services/events-tracker-service';

import IconClose from 'icons/icon-close';
import IconInfo from 'icons/icon-info';

const HelpBlock = ({ title, readUrl, watchUrl, onClose, t }) => {
    const handleCloseClick = () => {
        trackEvent('PRODUCT_UPDATES.CANCEL');
        onClose();
    }

    const handleReadClick = () => {
        trackEvent('PRODUCT_UPDATES.READ');
    }

    const handleWatchClick = () => {
        trackEvent('PRODUCT_UPDATES.WATCH');
    }

    return (
        <div className="help-block">
            <button className="btn help-block-close" onClick={handleCloseClick}>
                <IconClose />
            </button>

            <div className="help-block-aside">
                <IconInfo />
            </div>

            <div className="help-block-main">
                <div className="title">{ title }</div>

                {
                    readUrl || watchUrl ? (
                        <div className="actions btn-group btn-group-auto">
                            {
                                readUrl ? <a href={readUrl} target="_blank" rel="noopener noreferrer" className="btn btn-xsmall btn-secondary" onClick={handleReadClick}>{ t('Read') }</a> : null
                            }

                            {
                                watchUrl ? <a href={watchUrl} target="_blank" rel="noopener noreferrer" className="btn btn-xsmall btn-secondary" onClick={handleWatchClick}>{ t('Watch') }</a> : null
                            }
                        </div>
                    ) : null
                }
            </div>
        </div>
    );

}

export default withTranslation('common')(HelpBlock);
